import * as React from 'react';
import { connect } from 'react-redux';

import Pagination from 'components/pagination/Pagination';

import type { LocationWindow, PaginationLinks, PaginationMeta } from 'types';

type OwnProps = {
  meta: PaginationMeta,
  links: PaginationLinks,
  isLoading: boolean,
  onClick: (a: number) => void
};

type StateProps = {
  location: LocationWindow
};

type Props = OwnProps & StateProps;

class CreatorTilePagination extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { meta, links, location, isLoading, onClick } = this.props;

    if (isLoading) {
      return null;
    }

    return (
      <div className="creator-tile-pagination">
        <Pagination
          meta={meta}
          links={links}
          location={location}
          onClick={onClick}
          scrollToTopOnPageChange={false}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ router }): StateProps => ({
  location: router.location
});

export default connect(mapStateToProps)(CreatorTilePagination);
